import { render, staticRenderFns } from "./MitgliederProbenbenefitModal.vue?vue&type=template&id=68796e2e&"
import script from "./MitgliederProbenbenefitModal.vue?vue&type=script&lang=js&"
export * from "./MitgliederProbenbenefitModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports